/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import Avatar from 'react-avatar-edit'
import { editAvatarUser } from '../../../auth/core/_requests'
import { Button, ErrorLabel, LoadingIndicator, useModal } from '../../../../components'
import { ButtonType, showAlert, showError } from '../../../../../_metronic/helpers'
import { useFormik } from 'formik'
import { AvatarDto, useAuth } from '../../../auth'
import { uploadAvatarSchema } from './validation/uploadAvatarSchema'
import { useT } from '_metronic/i18n/Metronici18n'

export const UploadAvatarModal: FC = () => {
  const { closeModal } = useModal()
  const { reloadUser } = useAuth()
  const { t } = useT()

  const onCrop = (preview: string) => formik.setFieldValue('preview', preview)

  const onBeforeFileLoad = (elem: any) => {
    const file = elem.target.files[0]

    if (!file) return

    if (file.size > 10000000) {
      alert('Arquivo muito grande!')
      elem.target.value = ''
      return
    }

    formik.setFieldValue('file', file)
    formik.setFieldTouched('file', true)
  }

  const formik = useFormik({
    initialValues: {
      file: undefined as undefined | File,
      preview: '',
    },
    validationSchema: uploadAvatarSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true)
      try {
        const data: AvatarDto = {
          action: 'u',
          fileContent: values.preview,
          fileName: values.file?.name,
          fileType: values.file?.type,
        }
        await editAvatarUser(data)
        reloadUser()
        showAlert({ title: 'Sucesso', text: 'Imagem alterada com sucesso!', icon: 'success' })
        closeModal()
      } catch (error) {
        showError(error)
      } finally {
        setSubmitting(false)
      }
    },
  })

  return (
    <form noValidate onSubmit={formik.handleSubmit}>
      <div className='d-flex justify-content-center align-items-center'>
        <Avatar
          width={180}
          height={200}
          onCrop={onCrop}
          onBeforeFileLoad={onBeforeFileLoad}
          label='Enviar Imagem'
        />
      </div>
      {formik.touched.file && formik.errors.file && (
        <ErrorLabel className='text-center'>{formik.errors.file}</ErrorLabel>
      )}
      <div className='d-flex justify-content-center pt-5'>
        <Button
          type={ButtonType.Reset}
          className='btn-secondary me-3'
          onClick={closeModal}
          disabled={formik.isSubmitting}
        >
          {t('common.cancel')}
        </Button>
        <Button type={ButtonType.Submit} className='btn-primary' disabled={formik.isSubmitting}>
          {formik.isSubmitting ? <LoadingIndicator /> : t('common.save')}
        </Button>
      </div>
    </form>
  )
}
